import { ContactModelV2 } from 'Models/ContactModelV2';
import React from 'react';
import { mapContactCategory } from '../../utils/map_contact_category';
import { EntityContactCard } from '../EntityContactCard';
import { ContactDuplicateGroupProps } from './index.types';

export const ContactDuplicateGroup = ({
  phoneNumber,
  contacts,
  onNavigateToContact,
  className,
}: ContactDuplicateGroupProps) => {
  return (
    <div className={className}>
      <div className="my-2 px-2">
        <b>{ContactModelV2.formatNumber(phoneNumber)}</b> is also used in:
      </div>
      {contacts.map((contact) => (
        <div className="flex flex-col gap-2" key={contact.id}>
          <EntityContactCard
            hasContact
            image={contact?.avatarUrl}
            name={contact?.name}
            subTitle={mapContactCategory(contact)}
            onNavigateToContact={() => onNavigateToContact(contact)}
            isInactive={contact.deleted}
          />
        </div>
      ))}
    </div>
  );
};
